import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'
import React, { useContext, useState } from 'react'
import { UserContext } from '../../../../App'

const BACS = ({ accountData, setAccountData }) => {
  const { user } = useContext(UserContext)
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel>Employment Type</InputLabel>
            <Select
              value={accountData?.employee?.payroll?.employmentType ?? ''}
              onChange={(e) =>
                setAccountData((prev) => ({
                  ...prev,
                  employee: {
                    ...prev.employee,
                    payroll: {
                      ...prev.employee?.payroll,
                      employmentType: e.target.value,
                    },
                  },
                }))
              }
              label="Employment Type"
              disabled={!!user?.employee?.payroll?.employmentType}
            >
              <MenuItem value="Contractor">Contractor</MenuItem>
              <MenuItem value="PAYE">PAYE</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="title3">Bank Account Details</Typography>
        </Grid>
        <Grid item xs={12} lg={4}>
          <TextField
            label="Name on Account"
            value={accountData?.employee?.payroll?.bacsName ?? ''}
            fullWidth
            onChange={(e) =>
              setAccountData((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  payroll: {
                    ...prev.employee?.payroll,
                    bacsName: e.target.value,
                  },
                },
              }))
            }
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <TextField
            label="Account Number"
            value={accountData?.employee?.payroll?.bacsAccountNumber ?? ''}
            fullWidth
            onChange={(e) =>
              setAccountData((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  payroll: {
                    ...prev.employee?.payroll,
                    bacsAccountNumber: e.target.value,
                  },
                },
              }))
            }
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <TextField
            label="Sort Code"
            value={accountData?.employee?.payroll?.bacsSortCode ?? ''}
            inputProps={{
              maxLength: 8,
            }}
            fullWidth
            onChange={(e) => {
              let value = e.target.value.replace(/\D/g, '') // Remove non-digits
              value = value.replace(/^(\d{2})(\d{2})(\d{2}).*/, '$1-$2-$3') // Format as XX-XX-XX

              setAccountData((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  payroll: {
                    ...prev.employee?.payroll,
                    bacsSortCode: value,
                  },
                },
              }))
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="title3">Invoicing</Typography>
        </Grid>
        <Grid item xs={12} lg={4}>
          <TextField
            label="VAT Registration Number"
            value={accountData?.employee?.payroll?.vatNumber ?? ''}
            fullWidth
            helperText="Leave blank if you are not VAT registered. If set, VAT is added on top of your pay on generated invoices."
            onChange={(e) =>
              setAccountData((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  payroll: {
                    ...prev.employee?.payroll,
                    vatNumber: e.target.value,
                  },
                },
              }))
            }
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default BACS
